import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "react-lottie";
import CloseSVG from "../../../../images/icons/svg/close.svg";
import DocumentReferenceCard from "./DocumentReferenceCard.js";
import styles from "./DocumentReferencePanel.module.scss";
import loadingAnimation from "../../../../images/lotties/loader.json";
import httpClient from "../../../../lib/HttpClient";
import linkIcon from "../../../../images/icons/svg/link-icon.svg";
import security from "../../../../services/Security";
import fetchDocumentReferences from "../../../../actions/document/fetchDocumentReferences";

/* UI Kit */
import {
  Uikon,
  UikButton,
  UikFormInputGroup,
  UikDropdown,
  UikDropdownItem,
} from "@uik";

// TODO: "Shift References" feature removed — requires PaperView PDF migration.
// Original PDFTron implementation documented in memory/shift-references-feature.md

export default (props) => {
  const {
    docId,
    closeDocumentReferencePanel,
    versionId,
    versionNumber,
    originalDocumentId,
    isApproved,
    readOnly,
    onAnnotationSelect,
    selectAnnotationById,
    deleteAnnotationById,
  } = props;

  const [searchResults, setSearchResults] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [documentReferencesByPage, setDocumentReferencesByPage] = useState({});
  const [groupedReferenceCitations, setGroupedReferenceCitations] = useState(
    {}
  );

  const documentReferences = useSelector((state) => {
    return state.documentReferences;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    let documentReferencesObj = {};

    let groupedDocumentReferences = groupedReferences(
      documentReferences,
      "xfdf_highlight_id"
    );

    setGroupedReferenceCitations(groupedDocumentReferences);

    Object.keys(groupedDocumentReferences).forEach((xfdf_highlight_id) => {
      const group_representative_document_reference =
        groupedDocumentReferences[xfdf_highlight_id][0];

      const pageNumber = getPageNumber(group_representative_document_reference);

      if (!documentReferencesObj[pageNumber]) {
        documentReferencesObj[pageNumber] = [];
      }
      documentReferencesObj[pageNumber].push(
        group_representative_document_reference
      );
    });

    setDocumentReferencesByPage(documentReferencesObj);
  }, [documentReferences]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const close = () => {
    closeDocumentReferencePanel();
  };

  const renderEmtpyState = () => {
    return (
      <div className={styles.emptyStateMessage}>
        <img src={linkIcon}></img>
        <span className={styles.emptyStateMessageLineOne}>
          There are no references.
        </span>
        <span className={styles.emptyStateMessageLineTwo}>
          To create one, highlight some text and select the link icon.
        </span>
      </div>
    );
  };

  const groupedReferences = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const getPageNumber = (ref) => {
    // Use server-stored page number from reference data
    if (ref.page && ref.page.page_number) {
      return ref.page.page_number;
    }

    return null;
  };

  const renderDocumentReferenceList = () => {
    return (
      <div className={styles.conversationsContainer}>
        {Object.entries(documentReferencesByPage).map(
          ([key, documentReferences], index) => (
            <div key={index} className={styles.page}>
              <div className={styles.pageTitleContainer}>
                <div className={styles.title}>
                  {key !== "undefined" ? `page ${key}` : "page out of bounds"}
                </div>
              </div>
              <div className={styles.dividerContainer} />
              {documentReferences.map((dr, idx) => (
                <div className={styles.cardContainer}>
                  <DocumentReferenceCard
                    referenceCitationCount={
                      groupedReferenceCitations[dr.xfdf_highlight_id].length
                    }
                    page={key}
                    index={idx}
                    docId={docId}
                    documentReference={dr}
                    versionId={versionId}
                    versionNumber={versionNumber}
                    originalDocumentId={originalDocumentId}
                    isApproved={isApproved}
                    readOnly={readOnly}
                    selectAnnotationById={selectAnnotationById}
                    deleteAnnotationById={deleteAnnotationById}
                    onAnnotationSelect={onAnnotationSelect}
                  />
                  <div className={styles.dividerContainer} />
                </div>
              ))}
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <div
      className={
        props.showMobileSidePanel
          ? styles.mobileConversationsPanel
          : styles.conversationsPanel
      }
    >
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <div className={styles.leftContainer}>
            <div className={styles.title}>References</div>
          </div>
          <div className={styles.rightContainer}>
            <div onClick={close} className={styles.closeButton}>
              <img className={styles.closeIcon} src={CloseSVG} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.body}>
        {renderDocumentReferenceList(documentReferences)}
        {documentReferences &&
          documentReferences.length === 0 &&
          renderEmtpyState()}
      </div>
      {showLoader && (
        <div className={styles.loaderContainer}>
          <Lottie options={defaultOptions} height={92} width={82} />
          <p className={styles.loaderText}>Looking For Comments ...</p>
        </div>
      )}
    </div>
  );
};
